import { Field, useFormContext } from '@oscar/form';
import { Col, Icon, Input, Row, Select } from '@oscar/theme';
import { TextField } from 'common/components';
import React from 'react';
import { StatusInstance } from 'views/pages/create-instrulation/hooks/useStatus';

const { Option } = Select;

interface Props {
  statusRequest?: StatusInstance;
}

function SurfacePreparation({ statusRequest }: Props) {
  const [formContext] = useFormContext();
  const metaDataPaintingValidationDetail =
    formContext.selectors?.getDataByKey('metaDataPaintingValidationDetail') ||
    {};
  const submitQAQCsTime =
    formContext.selectors?.getInitalValue()?.submitQAQCsTime;

  return (
    <div className="surface-prep">
      {statusRequest?.state === 'EDIT' &&
      submitQAQCsTime?.submittedTime === 0 ? (
        <>
          <Row gutter={[15, 15]}>
            <Col span={12}>
              <p className="label-normal">Surface Prep</p>
              <Field
                name={[
                  'qaqcInfo',
                  'listQAQCDetail',
                  0,
                  'surfacePrep',
                  'surfacePrep',
                ]}
              >
                <Select
                  placeholder="Select Surface Preparation"
                  showSearch
                  dropdownClassName="certain-category-search-dropdown"
                  filterOption={(input: any, option: any) =>
                    option.children
                      ?.toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  allowClear
                  suffixIcon={<Icon icon="arrow-down" size={8} />}
                >
                  {metaDataPaintingValidationDetail?.surfacePreparation?.map?.(
                    (item: any, index: number) => (
                      <Option key={`${item.id}-${index}`} value={item?.id}>
                        {item.label}
                      </Option>
                    ),
                  )}
                </Select>
              </Field>
            </Col>
            <Col span={12}>
              <p className="label-normal">Cleaning Method</p>
              <Field
                name={[
                  'qaqcInfo',
                  'listQAQCDetail',
                  0,
                  'surfacePrep',
                  'cleaningMethod',
                ]}
              >
                <Input placeholder="Cleaning Method" maxLength={40} />
              </Field>
            </Col>
          </Row>
          <Row gutter={[15, 15]}>
            <Col span={12}>
              <p className="label-normal">Ave Surface Profile</p>
              <Field
                name={[
                  'qaqcInfo',
                  'listQAQCDetail',
                  0,
                  'surfacePrep',
                  'aveSurfaceProfile',
                ]}
              >
                <Input placeholder="Surface Profile" maxLength={40} />
              </Field>
            </Col>
            <Col span={12}>
              <p className="label-normal">Abrasive Type</p>
              <Field
                name={[
                  'qaqcInfo',
                  'listQAQCDetail',
                  0,
                  'surfacePrep',
                  'abrasiveType',
                ]}
              >
                <Input placeholder="Abrasive Type" maxLength={40} />
              </Field>
            </Col>
          </Row>
          <Row gutter={[15, 15]}>
            <Col span={12}>
              <p className="label-normal">Abrasive Sieve Size</p>
              <Field
                name={[
                  'qaqcInfo',
                  'listQAQCDetail',
                  0,
                  'surfacePrep',
                  'abrasiveSieveSize',
                ]}
              >
                <Input placeholder="Abrasive Sieve Size" maxLength={40} />
              </Field>
            </Col>
            <Col span={12}>
              <p className="label-normal">Pressure Used</p>
              <Field
                name={[
                  'qaqcInfo',
                  'listQAQCDetail',
                  0,
                  'surfacePrep',
                  'pressureUsed',
                ]}
              >
                <Input placeholder="Pressure Used" maxLength={40} />
              </Field>
            </Col>
          </Row>
        </>
      ) : (
        <>
          <Row gutter={[20, 20]}>
            <Col span={12}>
              <Field
                name={[
                  'qaqcInfo',
                  'listQAQCDetail',
                  0,
                  'surfacePrep',
                  'surfacePrep',
                ]}
              >
                <TextField
                  label="Surface Prep"
                  mappingData={
                    metaDataPaintingValidationDetail?.surfacePreparation
                  }
                />
              </Field>
            </Col>
            <Col span={12}>
              <Field
                name={[
                  'qaqcInfo',
                  'listQAQCDetail',
                  0,
                  'surfacePrep',
                  'cleaningMethod',
                ]}
              >
                <TextField label="Cleaning Method" />
              </Field>
            </Col>
          </Row>
          <Row gutter={[20, 20]}>
            <Col span={12}>
              <Field
                name={[
                  'qaqcInfo',
                  'listQAQCDetail',
                  0,
                  'surfacePrep',
                  'aveSurfaceProfile',
                ]}
              >
                <TextField label="Ave Surface Profile" />
              </Field>
            </Col>
            <Col span={12}>
              <Field
                name={[
                  'qaqcInfo',
                  'listQAQCDetail',
                  0,
                  'surfacePrep',
                  'abrasiveType',
                ]}
              >
                <TextField label="Abrasive Type" />
              </Field>
            </Col>
          </Row>
          <Row gutter={[20, 20]}>
            <Col span={12}>
              <Field
                name={[
                  'qaqcInfo',
                  'listQAQCDetail',
                  0,
                  'surfacePrep',
                  'abrasiveSieveSize',
                ]}
              >
                <TextField label="Abrasive Sieve Size" />
              </Field>
            </Col>
            <Col span={12}>
              <Field
                name={[
                  'qaqcInfo',
                  'listQAQCDetail',
                  0,
                  'surfacePrep',
                  'pressureUsed',
                ]}
              >
                <TextField label="Pressure Used" />
              </Field>
            </Col>
          </Row>
        </>
      )}
    </div>
  );
}

export default SurfacePreparation;
